/// <reference path="DOMAttached.js" />

class TabPopupMenu extends DOMAttached {
	constructor(el, options) {
		super(el, options);

		this.style.display = 'none';
		this.options.attachTo = document.getElementById(this.options.attachTo);
		this.safeObserve(this.options.attachTo, 'mouseover', this.onAttMouseOver.bind(this));
		this.safeObserve(this.el, 'mouseover', this.onAttMouseOver.bind(this));
		this.safeObserve(this.options.attachTo, 'mouseout', this.onAttMouseOut.bind(this));
		this.safeObserve(this.el, 'mouseout', this.onAttMouseOut.bind(this));

		this.reparented = false;

		this.registerUnloadAction(this.cleanUp.bind(this));
	}

	cleanUp() {
		this.options.attachTo = null;
	}

	onAttMouseOver(ev) {
		if (!this.visible) {
			this.style.display = '';
		} else {
			if (this.hideTimer)
				clearTimeout(this.hideTimer);
			this.hideTimer = undefined;
		}
	}

	onAttMouseOut(ev) {
		if (!this.hideTimer) {
			this.hideTimer = setTimeout(this.hide.bind(this), 1000);
		}
	}

	show() {
		if (!this.reparented) {
			this.el.remove();
			legacyGlobal.getToplevelElement().appendChild(this.el);
			this.reparented = true;
		}
		var attPos = this.options.attachTo.getBoundingClientRect();
		this.el.style.left = Math.round((attPos.left + (attPos.width - this.el.getBoundingClientRect().width) / 2)) + 'px';
		this.el.style.top = (attPos.top + attPos.height) + 'px';
		this.el.style.display = '';
		this.visible = true;

		if (legacyGlobal.currentlyActiveTabPopup)
			legacyGlobal.currentlyActiveTabPopup.style.display = 'none';
		legacyGlobal.currentlyActiveTabPopup = this;
	}

	hide() {
		this.el.style.display = 'none';
		this.visible = false;
		if (this.hideTimer)
			clearTimeout(this.hideTimer);
		this.hideTimer = undefined;
		legacyGlobal.currentlyActiveTabPopup = undefined;
	}
}
